"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateBidValidationSchema = void 0;
const Yup = __importStar(require("yup"));
const REQUIRED_FIELD = 'Este campo é obrigatório';
const MUST_BE_GREATER_THAN_ZERO = 'Deve ser maior que zero';
exports.CreateBidValidationSchema = Yup.object({
    company: Yup
        .string()
        .required(REQUIRED_FIELD),
    miles: Yup.string().test({
        test: value => {
            if (Number(value) <= 0) {
                return false;
            }
            return true;
        },
        message: MUST_BE_GREATER_THAN_ZERO
    }).required(REQUIRED_FIELD),
    price: Yup.string().test({
        test: value => {
            if (Number(value) <= 0) {
                return false;
            }
            return true;
        },
        message: MUST_BE_GREATER_THAN_ZERO
    }).required(REQUIRED_FIELD),
    pax: Yup.string().test({
        test: value => {
            if (Number(value) < 0) {
                return false;
            }
            return true;
        },
        message: 'Deve ser um valor válido'
    }).nullable().required(REQUIRED_FIELD),
});
